<!--
 * @Description: 硅灰模板
 * @Autor: yjx
 * @Date: 2021-11-17 16:31:54
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-29 17:05:57
-->
<template>
  <div id="template9" class="template_table_parent">
    <table class="template_table" border="1" cellpadding="0" cellspacing="0" @change="getChanges">
      <tr>
        <td colspan="9"></td>
        <td>检测编号：</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.code }}</td>
      </tr>
      <tr>
        <td>委托单位</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_01 }}</td>
        <td>品 种</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_02 }}</td>
        <td>出厂编号</td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_03.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>取样日期</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_04 }}</td>
      </tr>
      <tr>
        <td>检测单位</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_05 }}</td>
        <td>等 级</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_06 }}</td>
        <td>车牌号</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_07 }}</td>
        <td>试验日期</td>
        <td :class="{ bg3: !isViewResult }" class="select_date" colspan="2">
          <el-date-picker v-model="formData.cell_08.resultValue" type="datetime" format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择"> </el-date-picker>
        </td>
      </tr>
      <tr>
        <td>生产厂家</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_09 }}</td>
        <td>品 牌</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_10 }}</td>
        <td>环境温度</td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_11.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>代表批量</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_12 }}</td>
      </tr>
      <tr>
        <td>送货单位</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_13 }}</td>
        <td>样品来源</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.cell_14 }}</td>
        <td>环境湿度</td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          <el-input v-model="formData.cell_15.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>检测依据</td>
        <td class="bg4" colspan="2">
          <el-input v-model="formData.cell_16.resultValue" placeholder="请输入" disabled :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td>进场验收项目</td>
        <td colspan="2">材质证明</td>
        <td :class="{ bg5: !isViewResult }" colspan="3">
          <el-select v-model="formData.cell_17.resultValue" value-key="id">
            <el-option v-for="item in formData.cell_17.options" :key="item.id" :label="item.label" :value="item"></el-option>
          </el-select>
        </td>
        <td colspan="2">外观及颜色</td>
        <td :class="{ bg5: !isViewResult }" colspan="4">
          <el-select v-model="formData.cell_18.resultValue" value-key="id">
            <el-option v-for="item in formData.cell_18.options" :key="item.id" :label="item.label" :value="item"></el-option>
          </el-select>
        </td>
      </tr>
      <tr>
        <td>项目</td>
        <td>含水率（%）</td>
        <td>密度（g/cm³）</td>
        <td colspan="2">比表面积（BET）法（m²/kg）</td>
        <td colspan="2">SiO2含量（%）</td>
        <td colspan="2">总碱含量（%）</td>
        <td colspan="2">氯含量（%）</td>
        <td>净浆流动度（mm）</td>
      </tr>
      <tr>
        <td>测定值</td>
        <td :class="formData.cell_19.clsObj">
          <el-input v-model="formData.cell_19.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="formData.cell_20.clsObj">
          <el-input v-model="formData.cell_20.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="formData.cell_21.clsObj" colspan="2">
          <el-input v-model="formData.cell_21.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="formData.cell_22.clsObj" colspan="2">
          <el-input v-model="formData.cell_22.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="formData.cell_23.clsObj" colspan="2">
          <el-input v-model="formData.cell_23.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="formData.cell_24.clsObj" colspan="2">
          <el-input v-model="formData.cell_24.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="formData.cell_25.clsObj">
          <el-input v-model="formData.cell_25.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td rowspan="2">需水量比</td>
        <td>基准用水量（mm）</td>
        <td>对比用水量（mm）</td>
        <td colspan="2">测定值</td>
        <td>胶砂加水时间</td>
        <td :class="{ bg3: !isViewResult }" colspan="6">
          <el-date-picker v-model="formData.cell_29.resultValue" type="datetime" format="HH:mm" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择"> </el-date-picker>
        </td>
      </tr>
      <tr>
        <td>
          <el-input v-model="formData.cell_26.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td>
          <el-input v-model="formData.cell_27.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="formData.cell_28.clsObj" colspan="2">
          {{ formData.cell_28.resultValue }}
          <el-tooltip v-if="formData.cell_28.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_28.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
        <td colspan="2">7d基准水泥强度（Mpa）</td>
        <td :class="{ bg3: !isViewResult }" colspan="2">
          {{ formData.cell_30.resultValue }}
        </td>
        <td colspan="2">28d基准水泥强度（Mpa）</td>
        <td :class="{ bg3: !isViewResult }">
          {{ formData.cell_31.resultValue }}
        </td>
      </tr>
      <tr>
        <td rowspan="2">松散堆积密度</td>
        <td>试样+容器重（g）</td>
        <td>容器重（g）</td>
        <td>容器体积（L）</td>
        <td>测定值（g/cm³）</td>
        <td>试验期龄</td>
        <td colspan="3">7天快速法</td>
        <td colspan="3">28天快速法</td>
      </tr>
      <tr>
        <td :class="{ bg6: !isViewResult }">
          <el-input v-model="formData.cell_32.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg6: !isViewResult }">
          <el-input v-model="formData.cell_33.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg6: !isViewResult }">
          <el-input v-model="formData.cell_34.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="formData.cell_35.clsObj">
          {{ formData.cell_35.resultValue }}
          <el-tooltip v-if="formData.cell_35.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_35.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
        <td>强度项目</td>
        <td>检测值</td>
        <td>平均值</td>
        <td>活性指数（%）</td>
        <td>检测值</td>
        <td>平均值</td>
        <td>活性指数（%）</td>
      </tr>
      <tr>
        <td rowspan="2">烧矢量</td>
        <td>试样重（g）</td>
        <td>坩埚重（g）</td>
        <td>烧后坩埚+样重（g）</td>
        <td>烧矢量（%）</td>
        <td rowspan="6">抗压强度（Mpa)</td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_43.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td rowspan="6">{{ formData.cell_49.resultValue }}</td>
        <td :class="formData.cell_50.clsObj" rowspan="6">
          {{ formData.cell_50.resultValue }}
          <el-tooltip v-if="formData.cell_50.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_50.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_51.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td rowspan="6">{{ formData.cell_57.resultValue }}</td>
        <td :class="formData.cell_58.clsObj" rowspan="6">
          {{ formData.cell_58.resultValue }}
          <el-tooltip v-if="formData.cell_58.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_58.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
      </tr>
      <tr>
        <td :class="{ bg6: !isViewResult }">
          <el-input v-model="formData.cell_36.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg6: !isViewResult }">
          <el-input v-model="formData.cell_37.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg6: !isViewResult }">
          <el-input v-model="formData.cell_38.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="formData.cell_39.clsObj">
          {{ formData.cell_39.resultValue }}
          <el-tooltip v-if="formData.cell_39.exceed" class="item" effect="dark" placement="right">
            <div slot="content">{{ formData.cell_39.exceed }}</div>
            <i class="el-icon-s-flag"></i>
          </el-tooltip>
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_44.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_52.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td rowspan="4">备 注</td>
        <td rowspan="4" colspan="4">
          <el-input v-model="formData.cell_42.resultValue" type="textarea" :rows="4" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_45.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_53.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_46.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_54.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_47.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_55.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_48.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
        <td :class="{ bg3: !isViewResult }">
          <el-input v-model="formData.cell_56.resultValue" placeholder="请输入" :readonly="isViewResult" />
        </td>
      </tr>
      <tr>
        <td></td>
        <td>审核：</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">{{ defaultData.reviewer }}</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>试验：</td>
        <td :class="{ bg5: !isViewResult }" colspan="2">
          {{ user.inspector.label }}
        </td>
        <td></td>
      </tr>
    </table>
    <SetPopupDialog :visible.sync="popupVisible" :config="popupConfig" @updated="updated" @formChange="changeFun" />
  </div>
</template>
<script>
import SetPopupDialog from "../SetPopupDialog";
// import { getUsetListByPermission } from "@/api/index.js"

const dataArr = {
  cell_03: { resultValue: "", key: "ccbh", title: "出场编号", category: 3, type: 3, code: "cell_03" },
  cell_08: { resultValue: "", key: "syrq", title: "试验日期", category: 3, type: 3, code: "cell_08" },
  cell_11: { resultValue: "", key: "hjwd", title: "环境温度", category: 3, type: 3, code: "cell_11" },
  cell_15: { resultValue: "", key: "hjsd", title: "环境湿度", category: 3, type: 3, code: "cell_15" },
  cell_16: { resultValue: "JGJ52 - 2006", key: "jcyj", title: "检测依据", category: 6, type: 2, code: "cell_16", default: "JGJ52 - 2006" },

  cell_17: {
    resultValue: "",
    title: "材质证明",
    category: 7,
    type: 1,
    options: [
      { id: 0, label: "齐全且一致" },
      { id: 1, label: "不齐全或不一致" },
    ],
    clsObj: { bg5: true },
  },
  cell_18: {
    resultValue: "",
    title: "外观及颜色",
    category: 7,
    type: 1,
    options: [
      { id: 0, label: "相邻批次一致" },
      { id: 1, label: "相邻批次不一致" },
    ],
    clsObj: { bg5: true },
  },

  cell_19: { resultValue: "", key: "hsl", title: "含水率", category: 2, type: 3, code: "cell_19", clsObj: { bg2: true } },
  cell_20: { resultValue: "", key: "md", title: "密度", category: 2, type: 3, code: "cell_20", clsObj: { bg2: true } },
  cell_21: { resultValue: "", key: "bbmj", title: "比表面积", category: 2, type: 3, code: "cell_21", clsObj: { bg2: true } },
  cell_22: { resultValue: "", key: "eyhghl", title: "sio2含量", category: 2, type: 3, code: "cell_22", clsObj: { bg2: true } },
  cell_23: { resultValue: "", key: "zjhl", title: "总碱含量", category: 2, type: 3, code: "cell_23", clsObj: { bg2: true } },
  cell_24: { resultValue: "", key: "lhl", title: "氯含量", category: 2, type: 3, code: "cell_24", clsObj: { bg2: true } },
  cell_25: { resultValue: "", key: "jjldd", title: "净浆流动度", category: 2, type: 3, code: "cell_25", clsObj: { bg2: true } },
  cell_26: { resultValue: "", key: "jzysl", title: "基准用水量", category: 3, type: 3, code: "cell_26" },
  cell_27: { resultValue: "", key: "dbysl", title: "对比用水量", category: 3, type: 3, code: "cell_27" },
  cell_29: { resultValue: "", key: "jsjssj", title: "胶砂加水时间", category: 3, type: 3, code: "cell_29" },
  cell_30: { resultValue: "", key: "jzsnqd7", title: "7天基准水泥强度", category: 3, type: 1, code: "cell_30" },
  cell_31: { resultValue: "", key: "jzsnqd28", title: "28天基准水泥强度", category: 3, type: 1, code: "cell_31" },
  cell_32: { resultValue: "", key: "ssdjmd1", title: "试样+容器重", category: 3, type: 3, code: "cell_32" },
  cell_33: { resultValue: "", key: "ssdjmd2", title: "容器重", category: 3, type: 3, code: "cell_33" },
  cell_34: { resultValue: "", key: "ssdjmd3", title: "容器体积", category: 3, type: 3, code: "cell_34" },
  cell_36: { resultValue: "", key: "ssl1", title: "试样重", category: 3, type: 3, code: "cell_36" },
  cell_37: { resultValue: "", key: "ssl2", title: "坩埚重", category: 3, type: 3, code: "cell_37" },
  cell_38: { resultValue: "", key: "ssl3", title: "烧后坩埚+样重", category: 3, type: 3, code: "cell_38" },
  cell_42: { resultValue: "", key: "bz", title: "备注", category: 6, type: 3, code: "cell_42" },

  cell_43: { resultValue: "", key: "kyqd7_1", title: "7d抗压强度1", category: 6, type: 3, code: "cell_43" },
  cell_44: { resultValue: "", key: "kyqd7_2", title: "7d抗压强度2", category: 6, type: 3, code: "cell_44" },
  cell_45: { resultValue: "", key: "kyqd7_3", title: "7d抗压强度3", category: 6, type: 3, code: "cell_45" },
  cell_46: { resultValue: "", key: "kyqd7_4", title: "7d抗压强度4", category: 6, type: 3, code: "cell_46" },
  cell_47: { resultValue: "", key: "kyqd7_5", title: "7d抗压强度5", category: 6, type: 3, code: "cell_47" },
  cell_48: { resultValue: "", key: "kyqd7_6", title: "7d抗压强度6", category: 6, type: 3, code: "cell_48" },
  cell_51: { resultValue: "", key: "kyqd28_1", title: "28d抗压强度1", category: 6, type: 3, code: "cell_51" },
  cell_52: { resultValue: "", key: "kyqd28_2", title: "28d抗压强度2", category: 6, type: 3, code: "cell_52" },
  cell_53: { resultValue: "", key: "kyqd28_3", title: "28d抗压强度3", category: 6, type: 3, code: "cell_53" },
  cell_54: { resultValue: "", key: "kyqd28_4", title: "28d抗压强度4", category: 6, type: 3, code: "cell_54" },
  cell_55: { resultValue: "", key: "kyqd28_5", title: "28d抗压强度5", category: 6, type: 3, code: "cell_55" },
  cell_56: { resultValue: "", key: "kyqd28_6", title: "28d抗压强度6", category: 6, type: 3, code: "cell_56" },

  // 以下为计算属性
  cell_28: { resultValue: "", key: "xslbcdz", title: "需水量比测定值", category: 2, type: 3, code: "cell_28", clsObj: { bg2: true } },
  cell_35: { resultValue: "", key: "ssdjmdcdz", title: "松散堆积密度测定值", category: 2, type: 3, code: "cell_35", clsObj: { bg2: true } },
  cell_39: { resultValue: "", key: "sslcdz", title: "烧矢量测定值", category: 2, type: 3, code: "cell_39", clsObj: { bg2: true } },
  cell_49: { resultValue: "", key: "kyqd7", title: "7天抗压强度", category: 6, type: 3, code: "cell_49" },
  cell_57: { resultValue: "", key: "kyqd28", title: "28天抗压强度", category: 6, type: 3, code: "cell_57" },
  cell_50: { resultValue: "", key: "hxzs7", title: "7天活性指数", category: 1, type: 3, code: "cell_50", clsObj: { bg1: true } },
  cell_58: { resultValue: "", key: "hxzs28", title: "28天活性指数", category: 1, type: 3, code: "cell_58", clsObj: { bg1: true } },
};

export default {
  components: {
    SetPopupDialog,
  },
  props: {
    defaultData: {
      // 默认基本数据
      type: Object,
      default: () => {},
    },
    saveData: {
      // 保存的数据
      type: Object,
      default: () => {},
    },
    user: {
      // 试验人
      type: Object,
      default: () => {
        return {
          approver: {
            label: "",
          },
          inspector: {
            label: "",
          },
        };
      },
    },
    buttonType: {
      // 点击按钮的类型 save保存 submit提交（会校验必填项）
      type: String,
      default: "",
    },
    isViewResult: {
      // 查看结果还是录入数据
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formData: null,
      popupVisible: false,
      popupConfig: null,
      options: [],
      curKey: "xx",
    };
  },
  watch: {
    defaultData(val) {
      if(val) {
        this.formData["cell_30"].resultValue = this.defaultData.sevenDayAvg;
        this.formData["cell_31"].resultValue = this.defaultData.twentyEightDayAvg;
      }
    }
  },
  created() {
    if (Object.keys(this.saveData).length === 0) {
      this.formData = JSON.parse(JSON.stringify(dataArr));
    } else {
      let form = JSON.parse(JSON.stringify(this.saveData));
      for (let key in dataArr) {
        let item = form[key];
        if (item) {
          if (this.isViewResult) {
            // 查看，设置查看效果
            if (item.clsObj) {
              for (let i in item.clsObj) {
                item.clsObj[i] = false;
              }
              if (item.isQualified === 0) {
                item.clsObj["red-bg"] = true;
              } else if (item.type === 2 && item.isOverAdjacentFluctuation === 1) {
                item.clsObj["yellow-bg"] = true;
              }
            }
          }
        }else {
          item = dataArr[key];
          if (this.isViewResult) {
            // 查看，设置查看效果
            if (item.clsObj) {
              for (let i in item.clsObj) {
                item.clsObj[i] = false;
              }
              if (item.isQualified === 0) {
                item.clsObj["red-bg"] = true;
              } else if (item.type === 2 && item.isOverAdjacentFluctuation === 1) {
                item.clsObj["yellow-bg"] = true;
              }
            }
          }
        }
      }
      this.formData = form;
    }
  },
  mounted() {
    if (Object.keys(this.saveData).length === 0) {
      this.formData = JSON.parse(JSON.stringify(dataArr));
    } else {
      let form = JSON.parse(JSON.stringify(this.saveData));
      for (let key in dataArr) {
        let item = form[key];
        if (!item) {
          item = dataArr[key];
          if (this.isViewResult) {
            // 查看，设置查看效果
            if (item.clsObj) {
              for (let i in item.clsObj) {
                item.clsObj[i] = false;
              }
              if (item.isQualified === 0) {
                item.clsObj["red-bg"] = true;
              } else if (item.type === 2 && item.isOverAdjacentFluctuation === 1) {
                item.clsObj["yellow-bg"] = true;
              }
            }
          }
        }
      }
      this.formData = form;
    }
    //基准水泥强度取最近一条胶砂数据
    this.formData["cell_30"].resultValue = this.defaultData.sevenDayAvg;
    this.formData["cell_31"].resultValue = this.defaultData.twentyEightDayAvg;
    for (const key in this.formData) {
      let item = this.formData[key];
      if (item.options && item.resultValue && typeof item.resultValue === "string") {
        console.log(item);
        item.resultValue = JSON.parse(item.resultValue);
      }
    }

    if (this.defaultData) {
      // 处理快检数据
      for (const key in this.defaultData) {
        if (/^cell/.test(key)) {
          let res = this.defaultData[key];
          if (res && this.defaultData.content && this.defaultData.content[key] && this.defaultData.content[key].type === 1) {
            res = JSON.parse(res);
          }
          if (!this.formData[key]) {
            let data = dataArr[key];
            if (!data) {
              data = { resultValue: "", category: 6, type: 1 };
            }
            this.$set(this.formData, key, data);
          }
          if (!this.formData[key].resultValue) {
            this.formData[key].resultValue = res;
          }
        }
      }
    }
    const content = this.defaultData.content;
    if (content) {
      for (const key in content) {
        if (/^cell/.test(key)) {
          if (!this.formData[key]) {
            this.$set(this.formData, key, dataArr[key]);
          }
        }
      }
    }

    // console.log(this.defaultData, this.saveData, dataArr.length)
    console.log(this.formData, this.formData.cell_134);
  },
  methods: {
    getChanges() {
      // 有输入就核算
      let val = "";
      // 含水量比
      if (this.hasValues([26, 27])) {
        val = Math.round((this.getFieldVal(27) / this.getFieldVal(26)) * 100);
      }
      console.log(val);
      this.setFieldVal(28, val);
      val = "";
      //松散堆积密度
      if (this.hasValues([32, 33, 34])) {
        val = Math.round((this.getFieldVal(32) - this.getFieldVal(33)) / this.getFieldVal(34));
      }
      this.setFieldVal(35, val);
      val = "";
      //烧失量
      if (this.hasValues([36, 37, 38])) {
        val = Math.round(((this.getFieldVal(36) + this.getFieldVal(37) - this.getFieldVal(38)) / this.getFieldVal(36)) * 100);
      }
      this.setFieldVal(39, val);
      val = "";
      //7d活性指数
      if (this.hasValues([49, 30])) {
        val = Math.round((this.getFieldVal(49) / this.getFieldVal(30)) * 100);
      }
      this.setFieldVal(50, val);
      //21d活性指数
      if (this.hasValues([57, 31])) {
        val = Math.round((this.getFieldVal(57) / this.getFieldVal(31)) * 100);
      }
      this.setFieldVal(58, val);

      // 计算平均值
      this.calcAverage([43, 44, 45, 46, 47, 48], 49);
      this.calcAverage([51, 52, 53, 54, 55, 56], 57);
    },
    hasValues(indexArr, form) {
      if (!form) {
        form = this.formData;
      }
      let res = true;
      for (let i = 0, len = indexArr.length, key; i < len; i++) {
        key = "cell_" + indexArr[i];
        if (!form[key]) {
          console.log(key, "没有在formData中");
          res = false;
          break;
        } else if (form[key].resultValue === undefined || form[key].resultValue.length === 0) {
          console.log(key, "没有输入");
          res = false;
          break;
        }
      }

      return res;
    },
    // 计算堆积密度值
    calcTime(x, y, z) {
      let res = "";
      if (this.hasValues([x, y])) {
        let v1 = this.getFieldVal(x, true);
        let v2 = this.getFieldVal(y, true);
        res = (new Date(v2).getTime() - new Date(v1).getTime()) / 1000 / 60;
        res = Math.round(res);
      }
      this.setFieldVal(z, res);
    },
    // 计算平均值
    calcAverage(arr, z) {
      let res = "";
      if (this.hasValues(arr)) {
        let sum = 0;
        for (let key in arr) {
          sum = sum + this.getFieldVal(arr[key]);
        }
        res = (sum / arr.length).toFixed(2);
      }
      this.setFieldVal(z, res);
    },

    getFieldVal(x, isText, form) {
      if (!form) {
        form = this.formData;
      }
      if (isText) {
        return form["cell_" + x].resultValue;
      }
      return form["cell_" + x].resultValue * 1;
    },
    setFieldVal(x, val) {
      this.formData["cell_" + x].resultValue = val;
    },
    setData(curKey) {
      this.curKey = curKey;
      let config = {
        form: {},
      };
      for (let key in this.formData) {
        if (key.indexOf(curKey) >= 0) {
          config.form[key] = this.formData[key];
        }
      }
      this.popupConfig = config;
      this.popupVisible = true;
    },
    changeFun(form) {
      console.log(form);
      let res = "";
      switch (this.curKey) {
        case "cell_32_":
          if (this.hasValues(form, ["32_p01", "32_p02", "32_p03"])) {
            res = (((this.getFieldVal("32_p03", false, form) - this.getFieldVal("32_p01", false, form)) / this.getFieldVal("32_p02", false, form)) * 100).toFixed(2);
          }
          this.setFieldVal("32_p04", res);
          this.setFieldVal(32, res);
          break;
        case "cell_33_":
          if (this.hasValues(form, ["33_p01", "33_p02", "33_p03"])) {
            res = (((this.getFieldVal("33_p01", false, form) + this.getFieldVal("33_p02", false, form) - this.getFieldVal("33_p03", false, form)) / this.getFieldVal("33_p02", false, form)) * 100).toFixed(2);
          }
          this.setFieldVal("33_p04", res);
          this.setFieldVal(33, res);
          break;
        default:
          break;
      }
    },
    updated(data) {
      const { form } = data;
      for (let key in form) {
        console.log(key);
        this.formData[key] = form[key];
      }
    },
    // 外部获取数据
    getData() {
      let form = JSON.parse(JSON.stringify(this.formData));
      // form.cell_134.resultValue = JSON.stringify(form.cell_134.resultValue)
      // for (const key in form) {
      //   if (typeof form[key].resultValue === "object") {
      //     form[key].resultValue = JSON.stringify(form[key].resultValue);
      //   }
      // }
      return form;
    },
  },
};
</script>
<style lang="scss">
#template1 {
  width: 1200px;
}
</style>
